import { isMobile } from "react-device-detect";

import "./faq.scss";
import { useState } from "react";

function Faq() {
  const [questions, setQuestions] = useState([
    {
      title:
        "Caso meu filho danifique algum brinquedo ou perca alguma peça, o que acontece?",
      texts: [
        "Se, porventura, isso acontecer, nós enviaremos um orçamento contendo as alternativas para realizar a reposição da peça danificada. Caso o brinquedo fique inviabilizado de ser utilizado, você pagará 80% do valor de mercado, podendo ficar com o produto para si. Aconselhamos a leitura dos termos de uso no momento do preenchimento do cadastro no nosso site.",
      ],
      warning: [],
      isCollapsed: false
    },
    {
      title: "Como funciona a higiene dos produtos?",
      texts: [
        "A cada locação o brinquedo é desmontado, lavado com sabão neutro e, logo depois, desinfetado cuidadosamente com álcool 70%. Após isso, são entregues em sua casa embalados com toda a segurança e conforto que só a Adoleta oferece.",
      ],
      warning: [
        {
          theme: "OBSERVAÇÃO",
          text: "Não precisa devolver o brinquedo com a embalagem que foi feita a entrega!",
        },
      ],
      isCollapsed: false
    },
    {
      title: "Como será a entrega e a devolução dos brinquedos?",
      texts: [
        "Após a finalização da locação no nosso site junto a confirmação do pagamento, iremos entrar em contato, via whatsapp, informando o dia ideal para a entrega ou coleta prevista. Normalmente, este contato é realizado no dia anterior à entrega ou coleta.",
      ],
      warning: [],
      isCollapsed: false
    },
    {
      title:
        "E se eu não estiver no local na hora da entrega ou devolução, o que faço?",
      texts: [
        "Não há com o que se preocupar! Imprevistos podem acontecer, né? Caso não esteja no local, qualquer pessoa poderá receber o produto, desde que seja autorizado por você, através do whatsapp. Se você mora em apartamento, também não tem problema, podemos deixar na portaria do seu prédio.",
        "Não cobramos taxas de entregas e coletas! Porém, será cobrado um valor de retorno, calculado de acordo com o seu bairro, caso ninguém se encontre no local para o recebimento ou devolução dos brinquedos.",
      ],
      warning: [],
      isCollapsed: false
    },
    {
      title:
        "Eu posso renovar o aluguel de um brinquedo quantas vezes eu quiser?",
      texts: [
        "Sim! Na Adoleta o seu filho pode usufruir dos nossos brinquedos sem moderação. Porém, para que isso aconteça, será necessário demonstrar interesse novamente pelo produto.",
        "Mas como isso irá funcionar? É simples! Nós entraremos em contato para lhe avisar quando o prazo de locação estiver perto do vencimento e, caso queira o produto por mais tempo, você clica no botão de “renovação” em nosso site e apenas realiza um novo pagamento.",
      ],
      warning: [],
      isCollapsed: false
    },
    {
      title: "Meu filho não se adaptou com o brinquedo, posso trocá-lo?",
      texts: [
        "Claro que sim! É normal que às vezes o bebê não se identifique com o brinquedo escolhido. Você pode sim trocá-lo por outro, desde que, o produto o qual você queira substituir, ainda esteja disponível no site. Se por acaso o valor deste produto seja maior, será necessário pagar a diferença antecipadamente. Caso contrário, ou seja, o valor seja inferior, você não terá direito ao estorno.",
      ],
      warning: [
        {
          theme: "Atenção",
          text: "Só poderá efetuar a troca apenas nos primeiros 15 dias do período de locação, e, para isso, será cobrada uma “taxa de troca”, a qual deverá ser paga antes da entrega do novo brinquedo.",
        },
      ],
      isCollapsed: false
    },
    {
      title: "Os brinquedos acompanham pilhas ou baterias?",
      texts: [
        "Não. Para o seu funcionamento, alguns brinquedos necessitam de pilhas ou baterias, porém elas não vão acompanhadas junto com o produto. Antes de sair da loja e ser entregue, nós verificamos se o mesmo está funcionando.",
        "Fica a cargo dos pais ou responsáveis para providenciá-las, caso necessário.",
      ],
      warning: [],
      isCollapsed: false
    },
    {
      title: "Quais são as formas de pagamento?",
      texts: [
        "Nossos pagamentos podem ser realizados via transferência bancária (DOC/TED/PIX) ou cartões de crédito via PagSeguro ou Picpay.",
      ],
      warning: [],
      isCollapsed: false
    },
    {
      title: "Que tipos de brinquedos posso encontrar na Adoleta?",
      texts: [
        "Temos uma grande variedade de brinquedos selecionados, cuidadosamente, para cada faixa etária da criança. Cada uma possui a intenção de estimular o desenvolvimento cognitivo, motor e sensorial do seu filho, alegrando ainda mais o dia a dia deles. Também trabalhamos com as melhores marcas nacionais e importadas, sempre pensando na comodidade e no lazer do seu bebê.",
      ],
      warning: [
        {
          theme: "ATENÇÃO",
          text: "Nossa empresa possui apenas produtos infantis para crianças de 0 a 3 anos. Não trabalhamos com brinquedos para festa infantil!",
        },
      ],
      isCollapsed: false
    },
    {
      title: "Tem lista de espera?",
      texts: [
        "Sim. Quando algum dos nossos brinquedos estiverem indisponíveis, aparecerá um botão chamado “avise-me quando chegar”. Ao clicar, você irá automaticamente para a lista de espera. Assim que o produto estiver disponível novamente, você será informado.",
      ],
      warning: [],
      isCollapsed: false
    },
  ]);

  const toggleCollapseQuestion = (question) => {
    const newQuestions = questions.map((q) => {
      if (q.title === question.title) {
        q.isCollapsed = !q.isCollapsed;
      }
      return q;
    });
    setQuestions(newQuestions);
  }

  return (
    <div className="faq">
      <div className="container-fluid">
        <div className="container py-5 content">
          <h1
            className={`${
              isMobile ? "w-100 d-flex justify-content-center" : ""
            } title`}
            style={isMobile ? { fontSize: "34px" } : { fontSize: "66px" }}
          >
            Dúvidas frequentes
          </h1>
          <div className="w-100 d-flex justify-content-center questions">
            <div className="d-flex flex-column options">
              {questions.map((question, index) => {
                return (
                  <div
                    onClick={(e) => toggleCollapseQuestion(question)}
                    key={index}
                    className={`w-100 d-flex flex-column align-items-start dropdown-container ${
                      isMobile ? "mobile" : ""
                    }
                    `}
                  >
                    <button
                      className="btn w-100 d-flex justify-content-between align-items-center button-dropdown"
                      type="button"
                    >
                      <h1>{question.title}</h1>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        className="bi bi-plus-lg"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
                        />
                      </svg>
                    </button>
                    <div className={`${question.isCollapsed ? "d-flex" : "d-none"} flex-column texts`}>
                      {question.texts.map((text, index) => {
                        return <p key={index}>{text}</p>;
                      })}
                      {question.warning.map((warning, index) => {
                        return (
                          <p key={index}>
                            <strong>{warning.theme}: </strong>
                            {warning.text}
                          </p>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Faq;
